import React from 'react'
import clsx from 'clsx'
import { Box, Box as Container, Box as LogoContainer } from '@node-space/ui-components'
import { Logo } from 'components/logos/Logo'
import { useThemeContext } from 'hooks/context/useThemeContext'
import { LogoColor } from 'types/types'

export interface LogoHeaderProps {
  children?: React.ReactNode
  isMobileSticky?: boolean
  hasPadding?: boolean
}

export const LogoHeader = ({ children, isMobileSticky, hasPadding = true }: LogoHeaderProps) => {
  const { darkMode } = useThemeContext()
  return (
    <>
      <Container
        flex
        justify="between"
        width="full"
        paddingX={16}
        paddingY={12}
        {...(isMobileSticky && {
          divideBox: 'bottom',
          paddingB: 12,
          align: 'center',
        })}
        className={clsx('sm:px-8 bg-background-flat', {
          'sm:pt-4': hasPadding,
          'fixed md:relative z-20 sm:pb-4': isMobileSticky,
          'min-h-[64px] items-center': !hasPadding,
        })}
      >
        <LogoContainer
          {...(hasPadding && { paddingT: 8 })}
          {...(isMobileSticky && hasPadding && { paddingB: 8 })}
        >
          <Logo logoColor={darkMode ? LogoColor.LIGHT : LogoColor.DARK} />
        </LogoContainer>
        {children}
      </Container>
      {isMobileSticky && <Box className="h-headerMobile sm:h-header md:hidden mb-[1px]" />}
    </>
  )
}
